var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Seite__Icn/40px/Seite",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,13 C24.1045695,13 25,13.8954305 25,15 L25,28 C25,29.1045695 24.1045695,30 23,30 L13,30 C11.8954305,30 11,29.1045695 11,28 L11,15 C11,13.8954305 11.8954305,13 13,13 Z M23,15 L13,15 L13,28 L23,28 L23,15 Z M27,9 C28.1045695,9 29,9.8954305 29,11 L29,24 C29,25.1045695 28.1045695,26 27,26 L27,11 L15,11 C15,9.8954305 15.8954305,9 17,9 L27,9 Z",
    id: ".._.._src_svg_Icn_40px_Seite__Combined-Shape-Copy-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeite);
export default __webpack_public_path__ + "static/media/Seite.a652e04aa805c7ca59ce4eb53bc7192c.svg";
export { ForwardRef as ReactComponent };